module.exports = __webpack_public_path__ + "img/admin-website.8933ec83.webp";